import React from "react";
import { useNavigate } from "react-router-dom";
import "../../themes/HomePage.themed.css";

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleFeatureClick = (featureName: string) => {
    switch (featureName) {
      case "Monitor & Alert":
        navigate("/monitor");
        break;
      case "Intelligent Analysis":
        navigate("/analysis");
        break;
      case "Report Agent":
        navigate("/reports");
        break;
      case "Process Optimization":
        navigate("/optimization");
        break;
      default:
        break;
    }
  };

  return (
    <div className="msa-home">
      {/* Hero Section - Only this section has dark background */}
      <section className="hero-section">
        <div className="hero-content">
          <div>
            <div>
              <h1 className="hero-title">MSA</h1>
              <div className="hero-subtitle">
                AI-Powered Manufacturing Operations Management System
              </div>
            </div>
            <div className="hero-logo">
              <img src={require('../../assets/images/project-logo.png')} alt="MSA Logo" />
            </div>
          </div>
          <p className="hero-description">
            MSA transforms manufacturing operations with AI-driven automation
            and insights. Unify fragmented systems into a comprehensive platform
            for proactive management at contract manufacturer factories.
          </p>
        </div>
      </section>

      {/* Main Content Container - White background */}
      <div className="main-content">
        {/* Platform Overview Section */}
        <section className="content-section">
          <h3>Platform Overview</h3>
          <div className="platform-overview">
            <p>
              MSA consolidates fragmented standalone systems and incorporates
              artificial intelligence capabilities to assist teams in
              manufacturing operations management at contract manufacturer (CM)
              factories. Unlike traditional tools that require manual data
              crunching and reactive problem-solving, MSA leverages advanced
              AI/ML to turn disjointed data into proactive insights and
              automated support.
            </p>
            <div className="platform-features">
              <div className="features-row">
                <div
                  className="feature-item"
                  onClick={() => handleFeatureClick("Monitor & Alert")}
                >
                  <div className="feature-icon">📊</div>
                  <h4>Monitor & Alert</h4>
                  <p>
                    Real-time KPI monitoring with automated alerts and anomaly
                    detection
                  </p>
                </div>

                <div
                  className="feature-item"
                  onClick={() => handleFeatureClick("Intelligent Analysis")}
                >
                  <div className="feature-icon">🤖</div>
                  <h4>Intelligent Analysis</h4>
                  <p>
                    GenAI-powered chatbot for manufacturing data analysis and
                    recommendations
                  </p>
                </div>

                <div
                  className="feature-item"
                  onClick={() => handleFeatureClick("Report Agent")}
                >
                  <div className="feature-icon">📋</div>
                  <h4>Report Agent</h4>
                  <p>
                    Automated report generation for PVT daily and MP weekly
                    reports
                  </p>
                </div>

                <div
                  className="feature-item"
                  onClick={() => handleFeatureClick("Process Optimization")}
                >
                  <div className="feature-icon">⚡</div>
                  <h4>Process Optimization</h4>
                  <p>
                    AI-driven process analysis for efficiency improvements and
                    cost reduction
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePage;
